export const drawer = (state = { open: false }, action) => {
  // console.log('AT', action.type)
  // console.log('stateOpen', state.open)

  switch (action.type) {
    case 'DRAWER_TOGGLED':
      // console.log('toggled')
      return { open: action.payload }

    default:
      return state
  }
}

export default drawer
